import { Avatar, Settings } from 'rcd-cpp-ui/ui/icon';
import * as React from 'react';
import { fullName } from 'rcd-cpp-workspace/utils/string';
import { NavLink } from 'react-router-dom';
import { cn } from '../../utils';
import './userMenu.scss';
import { Workspace } from '../Icon/icon';
import { useActions } from '../HomeWorkspaceModal/homeWorkspaceModalActions';
import { useSelector } from '../../utils/useSelector';

const UserMenu = () => {
  const linkRef = React.useRef<HTMLDivElement>(null);
  const user = useSelector(state => state.app.user);
  const { openModal } = useActions();
  const name = fullName(user?.firstName, user?.lastName);
  const [expanded, setExpanded] = React.useState(false);
  React.useEffect(() => {
    const handleClickOutside = event => {
      if (linkRef.current && !linkRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return (
    <div
      ref={linkRef}
      className={cn('user-menu fs-mask', {
        'user-menu-expanded': expanded
      })}
    >
      <div onClick={() => setExpanded(!expanded)}>
        <div>{name}</div>
        <Avatar name={name} />
      </div>
      <div>
        <div>
          <div>
            <div>
              <Avatar name={name} />
            </div>
            <div>
              <span>{name}</span>
              <div>{user?.email}</div>
            </div>
          </div>
          <NavLink
            to={`${process.env.CPP_PLATFORM_URI.replace(
              'cpp-api',
              'cpp'
            )}/profile`}
            target="_blank"
            onClick={() => setExpanded(false)}
          >
            <div>
              <Settings />
            </div>
            <div>My Profile</div>
          </NavLink>
          <div
            onClick={() => {
              openModal();
              setExpanded(false);
            }}
          >
            <div>
              <Workspace isHome />
            </div>
            <div data-txt="Set Home Workspace ">Set Home Workspace</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserMenu;
